const UsersTypeEnum = {
  Buyer: 'buyer',
  Seller: 'seller',
  BuyerAndSeller: 'buyerandseller',
  Company: 'company'
}

export default UsersTypeEnum;